// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"d3c63991f622223da663","925":"f0fb9351764ea958a027"}[chunkId] + ".bundle.js";
};